import { put, all } from "redux-saga/effects";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "../../messages";
import updateDataGroupsFromRes from "./util";

function* updateMetaField(action) {
  const { id, dataGroupId, label, description, dataType, required, lookupChoices, oldField } = action.payload;
  const params = {
    label,
    description,
    data_type: dataType,
    required,
    lookup_choices: lookupChoices,
    old_field: oldField,
  };
  const { success, data, error } = yield* makeRequest.patch(`/data_groups/${dataGroupId}/meta_fields/${id}`, params);
  if (success && data) {
    const groups = yield updateDataGroupsFromRes(data, dataGroupId);
    yield all([
      put(actions.setDataGroups(groups)),
      put(
        actions.newSuccessEvent({
          message: messages.META_FIELD_UPDATE_SUCCESS,
          metaFieldId: id,
          dataGroupId,
        }),
      ),
    ]);
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_UPDATING_META_FIELD,
    });
  }
  return null;
}

export default updateMetaField;
